'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import { useEffect, useRef } from 'react';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TrendKeywordPager } from './TrendKeywordPager';
import { TrendKeywordToggle } from './TrendKeywordToggle';
import { TrendKeywordTrack } from './TrendKeywordTrack';
import { useTrendKeyword } from './useTrendKeyword';
export const TrendKeywordInline = () => {
  const $ = _c(13);
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP);
  let t0;
  if ($[0] !== isDesktop) {
    t0 = {
      enabled: isDesktop
    };
    $[0] = isDesktop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    keywords,
    step,
    isOpen,
    isPending,
    currentKeyword,
    search,
    toggle,
    close
  } = useTrendKeyword(t0);
  const containerRef = useRef(null);
  let t1;
  let t2;
  if ($[2] !== close || $[3] !== isOpen) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      const handlePointerDown = event => {
        if (!containerRef.current?.contains(event.target as Node)) {
          close();
        }
      };
      const handleKeyDown = event_0 => {
        if (event_0.key === "Escape") {
          close();
        }
      };
      document.addEventListener("pointerdown", handlePointerDown);
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("pointerdown", handlePointerDown);
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t2 = [isOpen, close];
    $[2] = close;
    $[3] = isOpen;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (!isPending && !currentKeyword) {
    return null;
  }
  let t3;
  if ($[6] !== currentKeyword || $[7] !== isOpen || $[8] !== keywords || $[9] !== search || $[10] !== step || $[11] !== toggle) {
    t3 = <div ref={containerRef} className="relative h-44 w-[300px] shrink-0">{isOpen ? <div className="absolute inset-x-0 top-0 z-30 flex flex-col rounded-medium border border-Gray-200 bg-Gray-white p-12 shadow-home"><TrendKeywordPager keywords={keywords} onSelect={search} /></div> : <div className="flex h-44 items-center gap-4 rounded-medium border border-Gray-200 bg-Gray-white pl-16 pr-12">{currentKeyword ? <button className={cn("flex h-36 min-w-0 flex-1 animate-fade items-center rounded-xsmall motion-reduce:animate-none", "transition-colors duration-150 active:bg-Gray-100 motion-reduce:transition-none", FOCUS_RING)} aria-label={`${currentKeyword.ranking}위 ${currentKeyword.keyword} 검색`} onClick={() => search(currentKeyword.keyword)}><TrendKeywordTrack keywords={keywords} step={step} size="desktop" /></button> : <span className="flex h-36 min-w-0 flex-1 items-center"><Skeleton typo="caption1" className="w-120 rounded-xsmall" /></span>}{currentKeyword && <TrendKeywordToggle isOpen={isOpen} onToggle={toggle} />}</div>}</div>;
    $[6] = currentKeyword;
    $[7] = isOpen;
    $[8] = keywords;
    $[9] = search;
    $[10] = step;
    $[11] = toggle;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};